import { Loading } from 'element-ui';
import 'xe-utils';
// import XEUtils from 'xe-utils/methods/xe-utils';

let loading = null;
export default {
  startLoading: function (msg) {
    loading = Loading.service({
      lock: true,
      text: msg || '加载中……',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
      customClass: 'allLoading',
    });
  },
  /* endLoading: XEUtils.debounce(function () {
    loading ? loading.close() : null
  },1500) */
  endLoading: function () {
    loading ? loading.close() : null;
  },
};
